module.exports = __webpack_public_path__ + "media/images/emblems/Sta_Maria_in_Calanca_wappen-94e38875920816f037c300debdce917a.svg";